import { render, staticRenderFns } from "./share-image-modal.vue?vue&type=template&id=9f72990c&scoped=true&lang=pug&"
import script from "./share-image-modal.vue?vue&type=script&lang=js&"
export * from "./share-image-modal.vue?vue&type=script&lang=js&"
import style0 from "./share-image-modal.vue?vue&type=style&index=0&id=9f72990c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f72990c",
  null
  
)

export default component.exports